import { message } from 'antd';
import API, { CloseTaskDto } from '../../API';
import { useEffect, useState } from 'react';
import { useLooseOrder, useTask } from 'reducers';
import { ClientOrderToPayView, Task } from 'types';
import { useNavigate } from 'react-router-dom';

export const useNewTaskClosing = (id: number | undefined) => {
	const [task] = useTask(id);
	const [order] = useLooseOrder(task?.orderId);
	const [otherOrders, setOtherOrders] = useState<ClientOrderToPayView[]>([]);
	const navigate = useNavigate();

	useEffect(() => {
		if (!order?.clientId || !task) {
			return;
		}

		fetchOtherOrders(order.clientId, task);
	}, [order?.clientId, task?.id]);

	const fetchOtherOrders = async (clientId: number, task: Task) => {
		try {
			if (!order) {
				return;
			}

			const orders = await API.orders2.client.toPay(clientId);
			setOtherOrders(orders.filter((o) => o.id !== task.orderId && o.type === task.orderType));
		} catch (e) {
			console.error(e);
			message.error(`Nie udało się pobrać danych (${e})`);
		}
	};

	const closeTask = async (dto: CloseTaskDto) => {
		if (!task) {
			return;
		}

		try {
			await API.tasks.close(task.id, dto);
			message.success('Zadanie zostało zamknięte');
			navigate(-1);

			return true;
		} catch (e) {
			console.error(e);
			message.error(`Nie udało się zamknąć zadania (${e})`);

			return false;
		}
	};

	return {
		task,
		order,
		otherOrders,
		closeTask,
	};
};
